/* 曹操傳・第 8 章：烏巢（200 年）
 * 西邊是官渡的曹營，一條小路往東北通到袁軍的糧屯烏巢；路上有三處袁軍的哨卡。烏巢營裡有三座糧倉。袁紹的援軍會從北邊來。 */
export const POSTS = [[2700, 2300], [4300, 2100], [5800, 2300]], WUCHAO = { x: 7500, y: 2200 }, GRANS = [[7200, 1900], [7800, 2000], [7450, 2550]], RELIEF = [7400, 300];
export default {
  id: 'wuchao', name: '烏巢', W: 9000, H: 4400, seed: 2002,
  bases: [[800, 2300], [WUCHAO.x, WUCHAO.y]],
  roads: [{ pts: [[800, 2300], [1800, 2350], POSTS[0], [3500, 2200], POSTS[1], [5100, 2200], POSTS[2], [6600, 2250], [WUCHAO.x, WUCHAO.y]], w: 120 }, { pts: [[WUCHAO.x, WUCHAO.y], [7400, 1200], RELIEF], w: 120 }],
  rocks: [[2000, 1200, 380, 180], [3600, 3300, 400, 190], [5000, 1100, 380, 180], [6300, 3400, 380, 180]],
  woods: 0.55,
  sight: 0.55,
  clearings: [[WUCHAO.x, WUCHAO.y, 750], [800, 2300, 450], ...POSTS.map(([x, y]) => [x, y, 260])],
  tents: [{ x: WUCHAO.x, y: WUCHAO.y, n: 9, r: 560, chief: true, col: '#7a5a2a', flag: '淳' }, { x: 800, y: 2300, n: 5, r: 360, col: '#3b5a99', flag: '曹' }],
  grass: [[2200, 1900, 220, 100], [3900, 2600, 220, 100], [5400, 1900, 220, 100], [6600, 1800, 220, 100]],
};
